
/** Recibe un objeto como por ejemplo una Enum y retorna un listado de objetos con value y text */
export function mapToSelect(obj: any) {
  return Object.entries(obj).map(([value, text]) => ({ text, value }));
}
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Asignacion from '@/model/Asignacion';
import Agrupacion from '@/model/Agrupacion';

@Options({
  components: {},
  name: 'ListadoAsignaciones',
})
export default class KistadoAsignaciones extends Vue {
  @Prop()
  private asignaciones!: Asignacion[];

  @Prop({ type: Boolean, default: false })
  private loading!: boolean;

  @Prop()
  private pagination!: any;

  private columns = [
    {
      label: 'Nro de expediente',
      field: 'numeroExp',
      align: 'center',
    },
    {
      label: 'Año',
      field: 'anioExp',
      align: 'center',
    },
    {
      label: 'Repartición',
      field: 'reparticion',
      align: 'center',
    },
    {
      label: 'Auxiliar',
      field: 'nombreAuxiliar',
      align: 'center',
    },
    {
      label: 'Fecha asignación',
      field: 'creacionFecha',
      align: 'center',
    },
  ];
  private localPagination = this.pagination;

  showAgrupaciones(agrupaciones: Agrupacion[]) {
    return `(${agrupaciones.map((agrupacion) => agrupacion.descripcion).join(', ')})`;
  }

  @Watch('localPagination', { deep: true })
  paginateLocal(val: any) {
    this.$emit('pagination', val);
  }
}
